import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { AssetTypesService } from 'app/_services/asset-types.service';
import { NotificationService } from 'app/_services/notification.service';
import { SiteWorkersService } from 'app/_services/site-workers.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'edit-worker-site-modal',
  templateUrl: './edit-worker-site-modal.component.html'
})
export class EditWorkerSiteModalComponent implements OnInit {
  @Input() siteTypeId: any;
  @Input() sites: any = [];
  @Input() skylarkUserId: any;

  public form: FormGroup;
  public validationErrors: any[] = [];
  public saveInProgress = false;
  public siteTypeAssetCategories: any[] = [];
  public canEditDelegate = false;
  newSites: any;
  editSites: any;
  copiedOptions: any;

  constructor(
    private activeModal: NgbActiveModal,
    private notificationService: NotificationService,
    private siteWorkersService: SiteWorkersService,
    private assetTypesService: AssetTypesService,
    private formBuilder: FormBuilder,
    private globals: Globals,
  ) { }

  ngOnInit() {
    this.newSites = this.sites.filter(s => !s.onSite);
    this.editSites = this.sites.filter(s => s.onSite);

    this.form = this.formBuilder.group({
      assetCategories: new FormControl('', [Validators.required]),
      guestsPermitted: new FormControl(false, [Validators.required]),
      managementDuty: new FormControl(true, [Validators.required]),
    });

    if (this.editSites.length) {
      const defaultValues = this.editSites[0];

      this.form.patchValue({
        assetCategories: defaultValues.assetCategories.map(this.mapAssetCategoryToDropdownItem),
        guestsPermitted: defaultValues.guestsPermitted,
        managementDuty: defaultValues.managementDuty,
      });
    }

    this.canEditDelegate = this.globals.user.routeRole !== 'site-delegate';

    this.getAllAssetTypesForSiteType(this.siteTypeId);

    this.checkForClipboardValues();
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onSubmit() {
    this.saveInProgress = true;
    const values = this.form.value;

    let requests = [];

    // edit
    for (let i = 0; i < this.editSites.length; i++) {
      const site = this.editSites[i];

      const body = {
        assetCategoryIds: values.assetCategories.map(item => item.value),
        guestsPermitted: values.guestsPermitted,
        managementDuty: values.managementDuty,
        siteDelegate: site.siteDelegate,
        id: site.workerSiteId,
      };

      requests.push(this.siteWorkersService.editSiteWorker(body));
    }

    // add
    for (let i = 0; i < this.newSites.length; i++) {
      const site = this.newSites[i];

      const body = {
        assetCategoryIds: values.assetCategories.map(item => item.value),
        guestsPermitted: values.guestsPermitted,
        managementDuty: values.managementDuty,
        siteId: site.id,
        skylarkUserId: this.skylarkUserId,
      };

      requests.push(this.siteWorkersService.addWorkerToSite(body));
    }

    forkJoin(requests).subscribe(() => {
      this.notificationService.notify('success', 'Worker Updated', 'Worker Sites have been updated.');
      this.activeModal.close('refresh');
    });
  }

  public getAllAssetTypesForSiteType(siteTypeId) {
    this.assetTypesService.getAllAssetTypesForSiteType(siteTypeId).subscribe((data: any) => {
      this.siteTypeAssetCategories = data.map(this.mapAssetCategoryToDropdownItem);
    });
  }

  public checkForClipboardValues() {
    const storedValue = localStorage.getItem('ui.clipboard.workerSiteOptions');

    if (storedValue) {
      this.copiedOptions = JSON.parse(storedValue);
    }
  }

  public pasteValues() {
    const copiedOptions = this.copiedOptions;

    let patchValue = {
      guestsPermitted: copiedOptions.guestsPermitted,
      managementDuty: copiedOptions.managementDuty,
    };

    if (this.siteTypeId !== copiedOptions.siteTypeId) {
      this.notificationService.notify('warning', `Can't paste asset categories from a different Site Type`);
    } else {
      patchValue['assetCategories'] = copiedOptions.assetCategories.map(this.mapAssetCategoryToDropdownItem);
    }

    this.form.patchValue(patchValue);
    this.form.markAsDirty();
  }

  private mapAssetCategoryToDropdownItem(element) {
    return {
      label: element.name,
      value: element.id,
      color: element.color,
    };
  }
}
